module.exports = __webpack_public_path__ + "assets/numbered_list-mobile.7c6866e2.svg";